import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

const OnboardingAlert = ({
  className,
  classes,
  error,
  message,
  visible,
  AlertProps,
}) => {
  return visible
    ? (
      <Alert
        classes={{
          root: classNames(classes.root, className),
        }}
        {...AlertProps}
        severity={error ? 'error' : 'info'}
      >
        <Typography
          variant={'h5'}
          weight={'bold'}
          color={'inherit'}
        >
          {message}
        </Typography>
      </Alert>
    ) : null;
};

OnboardingAlert.defaultProps = {
  className: '',
  error: false,
  visible: true,
  AlertProps: {
    variant: 'filled',
  },
};

OnboardingAlert.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  error: PropTypes.bool,
  message: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  AlertProps: PropTypes.object,
};

export default withStyles(styles)(OnboardingAlert);
